import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import {
  useGetAnnexesToProcess,
  useGetAnnexesToAttach,
} from "#/lib/api/annexe";
import { AnnexePage } from "#/components/pages/annexe/annexe-page";

export const Route = createFileRoute("/$tenantCode/$market/annexe")({
  beforeLoad: () => ({ getTitle: () => m["resources.annexe.name"]() }),
  component: AnnexeRoute,
});

function AnnexeRoute() {
  const { data: processData, isLoading: isProcessLoading } =
    useGetAnnexesToProcess();
  const { data: attachData, isLoading: isAttachLoading } =
    useGetAnnexesToAttach();

  return (
    <AnnexePage
      toProcess={processData?.member ?? []}
      toAttach={attachData?.member ?? []}
      isLoading={isProcessLoading || isAttachLoading}
    />
  );
}
